import axios from "axios";
import { useEffect, useRef, useState } from "react";
import loader from "../../../assets/images/loader.gif";
import Pagination from "../../../components/common/Pagination";
import ListAction from "../../../components/dashboard/admin-dashboard/ListAction";
import UserDetailModal from "../../../components/dashboard/admin-dashboard/detail-modal/UserDetailModal";
import TopHeader from "../../../components/dashboard/user-dashboard/TopHeader";
import { deleteUser, getAllCombUsers } from "../../../service/DashboardService";
import {
  getProfessionalById,
} from "../../../service/MainService";
import DoubleConfirm from "../../../components/dashboard/common/DoubleConfirm";

const AllUserList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [open, setOpen] = useState(false);
  const [userDetail, setUserDetail] = useState({});
  const [totalUserCount, setTotalUserCount] = useState(0);
  const topRef = useRef(null);
  const [doubleAlert, setDoubleAlert] = useState(false)
  const [deletingUserId, setDeletingUserId] = useState(null);


  useEffect(() => {
    fetchData();
    scrollToTop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getAllCombUsers(currentPage, 10);
      setUsers(response.Result);
      setTotalUserCount(response.TotalUsers);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching projects:", error);
      setLoading(false);
    }
  };

  const handlePageChange = (page, e) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const scrollToTop = () => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleViewClick = async (userId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await getProfessionalById(userId, token);
      setUserDetail(response);
      setOpen(true);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const handleExport = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/signup/export`
      );
      const exportUrl = response.data;
      window.open(exportUrl, "_blank");
    } catch (error) {
      console.error("Error exporting data:", error);
    }
  };

  const handleDeleteUser = (userId) => {
    setDeletingUserId(userId);
    setDoubleAlert(true);
  };


  const confirmDeleteUser = async () => {
    try {
      await deleteUser(deletingUserId);
      setUsers((prevUsers) =>
        prevUsers.filter((user) => user.UserId !== deletingUserId)
      );
      setDeletingUserId(null);
      setDoubleAlert(false)
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };


  const renderTableRows = () => {
    return users?.map((user, i) => (
      <tr
        key={i}
        className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700"
      >
        <td className="px-6 py-4">{user.Name || "NA"}</td>
        <td className="px-6 py-4">{user.Email || "NA"}</td>
        <td className="px-6 py-4">{user.Occupation || "NA"}</td>
        <td className="px-6 py-4">{user.Industry || "NA"}</td>
        <td className="px-6 py-4">{user.Concentration || "NA"}</td>
        <td className="px-6 py-4">{user?.Country?.countryName || "NA"}</td>
        <td className="px-6 py-4">
          <ListAction
            onViewClick={() => handleViewClick(user.UserId)}
            onDeleteClick={() => handleDeleteUser(user.UserId)}
            showDeleteButton={true}
          />
        </td>
      </tr>
    ));
  };



  return (
    <>
      <div ref={topRef} />
      <TopHeader />
      {users.length > 0 && (
        <div className="flex justify-start mb-5">
          <button
            type="button"
            className="flex items-center gap-2 text-gray-900 bg-gradient-to-r from-cyan-200 via-cyan-300 to-cyan-400 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
            onClick={handleExport}
          >
            Export
          </button>
        </div>
      )}
      {/* <SearchBar /> */}
      {loading ? (
        <div className="flex justify-center ">
          <img src={loader} alt="Loading" />
        </div>
      ) : (
        <div className="relative">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-center text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Name
                </th>
                <th scope="col" className="px-6 py-3">
                  Email
                </th>
                <th scope="col" className="px-6 py-3">
                  Occupation
                </th>
                <th scope="col" className="px-6 py-3">
                  Industry
                </th>
                <th scope="col" className="px-6 py-3">
                  Concentration
                </th>
                <th scope="col" className="px-6 py-3">
                  Country
                </th>
                <th scope="col" className="px-6 py-3"></th>
              </tr>
            </thead>
            <tbody>{renderTableRows()}</tbody>
          </table>

          {totalUserCount > 10 && (
            <Pagination
              currentPage={currentPage}
              totalItems={totalUserCount}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      )}
      <UserDetailModal open={open} setOpen={setOpen} userDetail={userDetail} />
      <DoubleConfirm open={doubleAlert} setOpen={setDoubleAlert} onConfirm={confirmDeleteUser} />
    </>
  );
};

export default AllUserList;
